import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { catchError, throwError } from 'rxjs';
import uuid4 from 'uuid4';
import { HttpResponse } from '../../../model/HttpResponse';
import { Modalidad } from '../../../model/Modalidad';
import { AcademyAdministratorOperation } from '../../../model/administrator/AcademyAdministratorOperation';
import { AcademyAdministratorType } from '../../../model/administrator/AcademyAdministratorType';
import { AdministratorEntity } from '../../../model/administrator/AdministratorEntity';
import { Category } from '../../../model/competitions/Category';
import { Competition, IdObject } from '../../../model/competitions/Competition';
import { CrosselingItem } from '../../../model/Crosseling/CrosselingItem';
import { CategoryLevel } from '../../../model/competitions/Level';
import { CompetitionType } from '../../../model/competitions/competitionType';
import { CompetitionService } from '../../../services/competition.service';
import { LoadingService } from '../../../services/loading.service';
import { PageHeaderComponent } from '../../shared/page-header/page-header.component';
import { CrudTableComponent } from '../../shared/tables/crud-table/crud-table.component';
@Component({
  selector: 'app-competition-form',
  standalone: true,
  imports: [
    InputTextareaModule,
    CalendarModule,
    InputMaskModule,
    SelectButtonModule,
    InputSwitchModule,
    InputTextModule,
    PageHeaderComponent,
    CrudTableComponent,
    ConfirmDialogModule,
    CommonModule,
    DialogModule,
    ReactiveFormsModule,
    FormsModule,
    MultiSelectModule,
    InputNumberModule,
    FloatLabelModule,
    TableModule,
    ButtonModule
  ],
  providers: [MessageService, ConfirmationService],
  templateUrl: './competition-form.component.html',
  styleUrl: './competition-form.component.scss',
})
export class CompetitionFormComponent implements OnInit {
  validateForm!: FormGroup;
  showForm: boolean = false;
  dialogHeader: string = '';

  @Input()
  isUpdateForm: boolean = false;

  @Input()
  competitionToUpdate!: Competition;

  @Input()
  levels!: CategoryLevel[];

  @Input()
  modality!: Modalidad;

  @Input()
  categories!: Category[];

  @Output()
  onCompetitionCreated: EventEmitter<Competition> =
    new EventEmitter<Competition>();

  @Output()
  onFormClosed: EventEmitter<boolean> = new EventEmitter<boolean>();

  competitionTypes: { label: string; value: CompetitionType }[] = [
    { label: 'Vinculados', value: CompetitionType.MEMBERS },
    { label: 'Externos', value: CompetitionType.EXTERNAL },
    { label: 'Vinculados y Externos', value: CompetitionType.MEMBERS_AND_EXTERNAL },
  ];

  categoriesOptions: { name: string; value: Category }[] = [];
  levelsSelected: CategoryLevel[] = [];
  categoriesSelected: Category[] = [];
  categoriesIdsInEvent: IdObject[] = [];
  filteredLevels: CategoryLevel[] = [];
  stateOptions: any[] = [
    { label: 'No', value: false },
    { label: 'Si', value: true },
  ];
  
  crosselingItems: CrosselingItem[] = [];
  showCrosselingDialog: boolean = false;
  editingCrosselingItem: CrosselingItem | null = null;
  editingIndex: number = -1;
  constructor(
    private fb: FormBuilder,
    private loadingService: LoadingService,
    private competitionService: CompetitionService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.filterLevelsByModality();
    if (this.isUpdateForm) {
      this.setLevelByCategoriesSelected(this.competitionToUpdate.categories);
      this.getEditForm(this.competitionToUpdate);
    } else {
      this.getFormNew();
    }
    this.showForm = true;
   
  }

  onLevelSelected(event: any) {
    this.levelsSelected = event.value;
    this.categoriesSelected = [];
    this.validateForm.get('categories')?.setValue([]);
    this.setCategoriesOptions(this.categories);
  }

  setCategoriesOptions(categories: Category[]) {
    // Filtrar categorías por modalidad y niveles seleccionados
    const modalityCategories = this.categories.filter(category => category.modality === this.modality);
    
    this.categoriesOptions = modalityCategories
      .filter((category) => {
        return this.levelsSelected.some(
          (level) => level.id === category.idCategoryLevel
        );
      })
      .map((category) => {
        return { name: category.name, value: category };
      });
  }

  filterLevelsByModality(): void {
    // Filtrar niveles específicos para la modalidad actual
    this.filteredLevels = this.levels.filter(level => 
      this.categories.some(category => 
        category.idCategoryLevel === level.id && 
        category.modality === this.modality
      )
    );
  }

  setLevelByCategoriesSelected(ids: IdObject[]) {
    this.categoriesIdsInEvent = ids;

    this.categoriesSelected = this.categories.filter((category: Category) =>
      ids.some((id) => id.id === category.id)
    );

    this.levelsSelected = this.filteredLevels.filter((level) =>
      this.categoriesSelected.some(
        (category) => category.idCategoryLevel === level.id
      )
    );
    this.setCategoriesOptions(this.categoriesSelected);
  }

  onCategorySelected(event: any) {
    console.log('Event',event);
  }


  getFormNew() {
    this.validateForm = this.fb.group({
      type: [null, [Validators.required]],
      name: [null, [Validators.required]],
      startDate: [null, [Validators.required]],
      endDate: [null, [Validators.required]],
      location: [null, [Validators.required]],
      baseDateToCalculateAge: [null, [Validators.required]],
      levels: [null, [Validators.required]],
      categories: [null, [Validators.required]],
      ordinaryStartDate: [null, [Validators.required]],
      ordinaryEndDate: [null, [Validators.required]],
      extraordinaryStartDate: [null, [Validators.required]],
      extraordinaryEndDate: [null, [Validators.required]],
      ordinaryAthleteAmount: [null, [Validators.required]],
      extraordinaryAthleteAmount: [null, [Validators.required]],
      ordinaryClubAmount: [null, [Validators.required]],
      extraordinaryClubAmount: [null, [Validators.required]],
      urlResolution: [null],
      urlImage: [null],
      isOpenToRegister: [false, [Validators.required]],
      isPublished: [false, [Validators.required]],
      digitalPaymentAvailable: [true, [Validators.required]],
      manualPaymentAvailable: [false, [Validators.required ]],
      hasCrosselling: [false, [Validators.required]],
    });
    this.dialogHeader = `Nuevo evento de la modalidad ${this.modality.toLowerCase()}`;
    this.isUpdateForm = false;
    this.showForm = true;
  }

  getEditForm(item: Competition) {
    this.validateForm = this.fb.group({
      id: [item.id, [Validators.required]],
      type: [item.type, [Validators.required]],
      name: [item.name, [Validators.required]],
      startDate: [item.startDate, [Validators.required]],
      endDate: [item.endDate, [Validators.required]],
      location: [item.location, [Validators.required]],
      baseDateToCalculateAge: [
        item.baseDateToCalculateAge,
        [Validators.required],
      ],
      levels: [this.levelsSelected, [Validators.required]],
      categories: [this.categoriesSelected, [Validators.required]],
      ordinaryStartDate: [
        item.registerDates.ordinary.start,
        [Validators.required],
      ],
      ordinaryEndDate: [item.registerDates.ordinary.end, [Validators.required]],
      extraordinaryStartDate: [
        item.registerDates.extraordinary.start,
        [Validators.required],
      ],
      extraordinaryEndDate: [
        item.registerDates.extraordinary.end,
        [Validators.required],
      ],
      ordinaryAthleteAmount: [
        item.registerAmounts.ordinary.athlete,
        [Validators.required],
      ],
      extraordinaryAthleteAmount: [
        item.registerAmounts.extraordinary.athlete,
        [Validators.required],
      ],
      ordinaryClubAmount: [
        item.registerAmounts.ordinary.club,
        [Validators.required],
      ],
      extraordinaryClubAmount: [
        item.registerAmounts.extraordinary.club,
        [Validators.required],
      ],
      urlResolution: [item.urlResolution || ''],
      urlImage: [item.urlImage || ''],
      isOpenToRegister: [item.isOpenToRegister, [Validators.required]],
      isPublished: [item.isPublished, [Validators.required]],
      digitalPaymentAvailable: [item.payment.digitalPaymentAvailable, [Validators.required]],
      manualPaymentAvailable: [item.payment.manualPaymentAvailable, [Validators.required ]],
      hasCrosselling: [item.hasCrosselling || false, [Validators.required]],
    });
    this.dialogHeader = `Editar evento ${item.name}`;
    this.isUpdateForm = true;
    this.showForm = true;
    
    // Cargar items de venta cruzada si existen
    if (item.customData?.crosselingItems) {
      this.crosselingItems = [...item.customData.crosselingItems];
    }
  }


  saveCompetition() {
    if (this.validateForm.valid) {
      this.loadingService.showLoading();
      const competition = this.buidlCompetition(this.validateForm.value);
      const entity: AdministratorEntity = {
        operation: AcademyAdministratorOperation.CREATE,
        type: AcademyAdministratorType.COMPETIIONS,
        payload: competition,
      };

      this.competitionService
        .sendRequest(entity)
        .pipe(catchError(this.handleError.bind(this)))
        .subscribe((res: HttpResponse) => {
          if (res.code === 200) {
            this.messageService.add({
              severity: 'success',
              summary: 'Éxito',
              detail: 'Competición creada correctamente',
            });
            this.showForm = false;
            this.onCompetitionCreated.emit(entity.payload);
            this.loadingService.hideLoading();
          }
        });
    }
  }

  updateCompetition() {
    if (this.validateForm.valid) {
      this.confirmationService.confirm({
        message: '¿Estas seguro de actualizar el evento?',
        header: 'Confirmar',
        acceptLabel: 'Si',
        rejectLabel: 'No',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.loadingService.showLoading();
          const competition = this.buidlCompetition(this.validateForm.value);
          const entity: AdministratorEntity = {
            operation: AcademyAdministratorOperation.UPDATE,
            type: AcademyAdministratorType.COMPETIIONS,
            payload: competition,
          };

          this.competitionService
            .sendRequest(entity)
            .pipe(catchError(this.handleError.bind(this)))
            .subscribe((res: HttpResponse) => {
              if (res.code === 200) {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Éxito',
                  detail: 'Evento Actualizado correctamente',
                });
                this.showForm = false;
                this.onCompetitionCreated.emit(entity.payload);
                this.loadingService.hideLoading();
              }
            });
        },
      });
    }
  }

  buidlCompetition(formCompetition: any) {
    const competition: Competition = {
      id: this.isUpdateForm ? formCompetition.id : uuid4(),
      type: formCompetition.type,
      name: formCompetition.name,
      startDate: formCompetition.startDate,
      endDate: formCompetition.endDate,
      location: formCompetition.location,
      baseDateToCalculateAge: formCompetition.baseDateToCalculateAge,
      categories: formCompetition.categories.map((category: Category) => {
        return { id: category.id };
      }),
      registerDates: {
        ordinary: {
          start: formCompetition.ordinaryStartDate,
          end: formCompetition.ordinaryEndDate,
        },
        extraordinary: {
          start: formCompetition.extraordinaryStartDate,
          end: formCompetition.extraordinaryEndDate,
        },
      },
      registerAmounts: {
        ordinary: {
          athlete: formCompetition.ordinaryAthleteAmount,
          club: formCompetition.ordinaryClubAmount,
        },
        extraordinary: {
          athlete: formCompetition.extraordinaryAthleteAmount,
          club: formCompetition.extraordinaryClubAmount,
        },
      },
      urlResolution: formCompetition.urlResolution,
      urlImage: formCompetition.urlImage,
      isOpenToRegister: formCompetition.isOpenToRegister,
      isPublished: formCompetition.isPublished,
      modality: this.modality,
      urlToRegister: '',
      payment: {
        digitalPaymentAvailable: formCompetition.digitalPaymentAvailable || true,
        manualPaymentAvailable: formCompetition.manualPaymentAvailable || false,
        paymentByEvents: false,
      },
      hasCrosselling: formCompetition.hasCrosselling || false,
      customData: formCompetition.hasCrosselling && this.crosselingItems.length > 0 ? {
        crosselingItems: this.crosselingItems
      } : undefined
    };
    return competition;
  }

  closeDialog() {
    this.validateForm.reset();
    this.crosselingItems = [];
    this.onFormClosed.emit(true);
    this.showForm = false;
  }

  addCrosselingItem() {
    this.editingCrosselingItem = {
      id: '',
      name: '',
      description: '',
      amount: 0,
      urlImage: ''
    };
    this.editingIndex = -1;
    this.showCrosselingDialog = true;
  }

  editCrosselingItem(item: CrosselingItem, index: number) {
    this.editingCrosselingItem = { ...item };
    this.editingIndex = index;
    this.showCrosselingDialog = true;
  }

  saveCrosselingItem() {
    if (this.editingCrosselingItem) {
      if (this.editingIndex === -1) {
        // Nuevo item
        this.editingCrosselingItem.id = uuid4();
        this.crosselingItems.push(this.editingCrosselingItem);
      } else {
        // Editar item existente
        this.crosselingItems[this.editingIndex] = this.editingCrosselingItem;
      }
      this.closeCrosselingDialog();
    }
  }

  deleteCrosselingItem(index: number) {
    this.confirmationService.confirm({
      message: '¿Estás seguro de eliminar este item de venta cruzada?',
      header: 'Confirmar',
      acceptLabel: 'Sí',
      rejectLabel: 'No',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.crosselingItems.splice(index, 1);
      }
    });
  }

  closeCrosselingDialog() {
    this.showCrosselingDialog = false;
    this.editingCrosselingItem = null;
    this.editingIndex = -1;
  }

  handleError(error: HttpErrorResponse) {
    this.loadingService.hideLoading();
    if (error.status === 422) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail:
          'No se puede procesar este evento, puede que ya exista un evento con el mismo nombre',
      });
      console.error('An error occurred:', error.error);
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Ha ocurrido un error inesperado, por favor intenta de nuevo',
      });
      this.validateForm.reset();
      console.error(
        `Backend returned code ${error.status}, body was: `,
        error.error
      );
    }
    // Return an observable with a user-facing error message.
    return throwError(
      () => new Error('Something bad happened; please try again later.')
    );
  }
}
